/* MICAVO REFILL-UPSELL IM WARENKORB + WARENKORB-KOMPATIBILITAET (Prestige 11)
 * ---------------------------------------------------------------------------
 * 1) Klick-Handler fuer die "+ Hinzufuegen"-Buttons aus snippets/mvq-cart-upsell.liquid
 *    und snippets/apu-cart-cross-sell.liquid (Attribut data-mvq-add).
 *    Ablauf: POST /cart/add.js -> Drawer-Section + Warenkorb neu laden ->
 *    'cart:change' im Prestige-11-Format (cart.sections) senden, damit der
 *    Drawer, Zaehler usw. sich selbst aktualisieren. Auf /cart wird neu geladen.
 *
 * 2) Kompatibilitaets-Shim: Prestige 11 erwartet bei 'cart:change' gerenderte
 *    Sections im Event (event.detail.cart.sections). Eigene Skripte (theOne-Buybox,
 *    Sticky-ATC) senden noch das alte Prestige-7-Format ohne Sections. Solche Events
 *    werden abgefangen, die Drawer-Section wird nachgeladen und das Event im neuen
 *    Format erneut gesendet.
 *
 * Eingebunden in: layout/theme.liquid (global, defer).
 * Portiert auf Prestige 11.4.1 am 20.10.2026 (Claude).
 */
(function () {
  'use strict';

  if (window.__mvqUpsell) return;
  window.__mvqUpsell = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawerSectionId() {
    var el = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function loadCartWithSections() {
    var sid = drawerSectionId();
    var cartP = fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    var secP = sid
      ? fetch(root + '?sections=' + encodeURIComponent(sid)).then(function (r) { return r.json(); })
      : Promise.resolve({});
    return Promise.all([cartP, secP]).then(function (res) {
      var cart = res[0];
      cart.sections = res[1] || {};
      return cart;
    });
  }

  function dispatchCartChange(target, detail) {
    (target || document.documentElement).dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: detail }));
  }

  /* ---- 2) Shim fuer Events im alten Format ---- */
  window.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    if (detail.__mvqShim || (detail.cart && detail.cart.sections)) return;
    event.stopImmediatePropagation();
    loadCartWithSections().then(function (cart) {
      var newDetail = Object.assign({}, detail, { cart: cart, __mvqShim: true });
      if (!newDetail.baseEvent) newDetail.baseEvent = 'variant:add';
      dispatchCartChange(event.target === document ? document.documentElement : event.target, newDetail);
    }).catch(function () {});
  }, true);

  /* ---- 1) 1-Klick-Hinzufuegen im Warenkorb ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mvq-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = parseInt(btn.getAttribute('data-mvq-add'), 10);
    if (!id) return;

    var onCartPage = !!btn.closest('.shopify-section--main-cart');

    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        if (onCartPage) {
          window.location.reload();
          return;
        }
        return loadCartWithSections().then(function (cart) {
          dispatchCartChange(document.documentElement, { baseEvent: 'line-item:change', cart: cart, __mvqShim: true });
        });
      })
      .catch(function () {
        window.location.reload();
      });
  }, false);
})();
